export default __webpack_public_path__ + "static/media/bg.a35f510d.png";